<template>
    <div class="footer">
        <div class="container">
            <!-- <div class="icon_w">
                <a target="_blank" :href="getLink('/faq/index.html')" class="about">About Us</a>
                <a @click="clickShowFeedBack()" href="javascript:void(0);"
                    class="feed-back-footer about">Feedback</a>
                <i></i>
            </div> -->
            <!-- 20210917 新增社交 媒体跳转 start -->
            <slot>
                <social-contact/>
            </slot>
            <!-- 20210917 新增社交 媒体跳转 end -->
            <div class="con_r">
                <span>
                    <a target="_blank" :href="getLink('/faq/index.html')" class="about">About Us
                    </a>
                </span>
                <span>
                    <a target="_blank" :href="getLink('/protocol/privacy_new.html')">Privacy
                    </a>
                </span>
                <span>
                    <a target="_blank" :href="getLink('/protocol/refund.html')">Refund Policy
                    </a>
                </span>
                <span>
                    <a target="_blank" :href="getLink('/protocol/terms_new.html')">Terms
                    </a>
                </span>
                <span>
                    <a target="_blank" :href="getLink('/protocol/cookie.html')">Cookie Policy
                    </a>
                </span>
                <span>
                    <a target="_blank" :href="getLink('/protocol/california_notice.html')">Privacy Notice
                    </a>
                </span>
                <span>
                    <a target="_blank" @click="clickga('User_Choice');"
                        :href="getLink('/protocol/user_choice.html')">User's Choice
                    </a>
                    <i></i>
                </span>
                <span>
                    <a target="_blank" @click="clickga('Contact');"
                        :href="getLink('/protocol/contact.html')">Contact Us
                    </a>
                </span>
                <span>
                    <a target="_blank" :href="getLink('/protocol/intellectual.html')">
                        INTELLECTUAL PROPERTY RIGHTS
                        <i></i>
                    </a>
                </span>
                <span>© {{crtime}} {{companyName}}
                </span>
                <span><img class="qianhai" src="./images/qianhai1.png" /></span>
            </div>
        </div>
        <!-- <feedback></feedback> -->
    </div>
</template>
<script>
import util from '@utils/util';
import socialContact from './social-contact';
// import feedback from '../../feedback-alive';

export default {
    name: 'alive-footer',
    components: {
        socialContact
        // feedback
    },
    computed: {
        crtime() {
            return new Date().getFullYear();
        },
        companyName() {
            return window.location.hostname === 'www.shanghaileyu.com' ? '上海勒域科技有限公司(Shanghai Leyu Science and Technology Center)' : '';
        }
    },
    methods: {
        // 显示反馈
        clickShowFeedBack() {
            this.$lmBus.$emit('clickShowFeedBack', 'convertView');
        },
        getLink(pathname) {
            // 带参传递
            const json = {
                pathname,
                search: {}
            };
            return util.directToPath(json);
        }
    }
};
</script>
<style lang="less" scoped>
    @import url('../../../biz/css/_grid');

    .footer {
        height: 65px;
        background: #000;
        font-size: 14px;
        width: 100%;
        z-index: 999;

        .container {
            text-align: center;
            background: #000;
        }

        .icon_w {
            overflow: hidden;
            //float: left;
            margin-right: 10px;
            display: inline-block;

            a {
                display: inline-block;
                vertical-align: middle;
                margin-left: 15px;
                background-size: cover;
                line-height: 65px;
            }

            .contect {
                margin-left: 10px;
            }
        }

        .about {
            font-size: 14px;
            line-height: 65px;
            margin-left: 10px;
        }

        i {
            margin-left: 10px;
        }

        .con_r {
            //float: right;

            display: inline-block;
            vertical-align: top;

            span {
                white-space: nowrap;
                font-size: 14px;
                line-height: 65px;
                position: relative;
                margin-right: 25px;
                color: #fff;

                i {
                    width: 4px;
                    height: 4px;
                    background: #fff;
                    border-radius: 2px;
                    position: absolute;
                    top: 7px;
                    right: -10px;
                }
            }

            .f_down_w {
                float: right;

                a {
                    float: left;
                    width: 145px;
                    height: 40px;
                    border-radius: 5px;
                    text-align: center;
                    margin-top: 14px;
                    margin-left: 10px;

                    img {
                        width: 147px;
                        height: 42px;
                    }
                }
            }
        }
    }

    @media (max-width:@mobile) {
        .footer {
            height: auto;
            margin-top: 0;

            .icon_w {
                float: none;
                display: block;
                text-align: center;
                padding-top: 0px;

                a {
                    float: none;
                    display: inline-block;
                    vertical-align: middle;
                    margin-top: 0;
                }
            }

            .con_r {
                margin-top: 10px;
                padding-bottom: 20px;

                span {
                    margin-right: 0px;
                    line-height: 1.2;

                    i {
                        position: static;
                        display: inline-block;
                        vertical-align: middle;
                        margin: 0 6px 0 3px;
                    }
                }
            }

            .about {
                line-height: 1em;
            }

            .contect {
                margin-left: 10px;
            }

            .container {
                width: auto;
            }

            .f_down_w {
                float: none !important;
            }
        }
    }

    @media (max-width:1000px) {
        .footer {
            .con_r {
                float: inherit;
                text-align: center;
            }

            .icon_w a {
                margin-left: 10px;
            }
        }
    }

    .qianhai{
        width: 140px;
        height: 33px;
        vertical-align: middle;
    }
</style>
